import { sidebarMenu } from "@/components/navigation/links";
import { useQueryClient } from "@tanstack/react-query";
import { authStore } from "@/store/auth";
import { useNavigate } from "react-router-dom";
import { useSnapshot } from "valtio";

import Logo from "@/assets/images/zct-logo.jpg";
import Button from "@/components/buttons/Button";
import CTA from "@/components/CTA";
import MenuLink from "@/components/navigation/MenuLink";



const Sidebar = () => {
    const navigate = useNavigate();
    const auth = useSnapshot(authStore);
    const queryClient = useQueryClient();

    const logout = () => {
        auth.logout();
        // The query cache outlives the session — it is created once for the app and
        // keyed only on filters, never on who is signed in. Without this the next
        // person to sign in on this browser is served the previous applicant's cached
        // applications, licences and inspections until each query happens to refetch.
        queryClient.clear();
        navigate("/auth/login", { replace: true });
        
    }

    return (
        <div className="h-screen overflow-y-auto ">
            <div className="flex flex-col justify-between min-h-full px-4 py-4 bg-white shadow-md border-r border-gray-100">

                <nav className="text-xs">
                    <div className="flex items-center gap-4 mb-8">
                        <img src={Logo} className="h-10 w-auto" />

                        <h4 className="text-secondary text-lg font-medium">
                            ZCT Platform
                        </h4>
                    </div>

                    <div className="space-y-4">
                        {
                            sidebarMenu.map((el) => (
                                <div className="space-y-2" key={el.heading}>
                                    <h4 className="text-xs text-secondary/70 uppercase">
                                        {el.heading}
                                    </h4>

                                    {
                                        el.menus.map((menu, index) => (
                                            <MenuLink
                                                content={menu}
                                                key={index}
                                            />
                                            // <AccessGuard permissions={menu.permissions} key={index}>

                                            // </AccessGuard>
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </div>
                </nav>

                <div className="space-y-4">
                    <CTA
               
                    >
                        <div>
                            <h2 className="text-primary text-sm font-bold">
                                Top Reasons Why You Should Invest In Zanzibar.
                            </h2>

                            <p className="text-xs text-gray-600 text-left mt-2">
                                The magnetic charm of Africa is hard to resist, and anyone who has lived...
                            </p>
                        </div>
                    </CTA>
                    <Button
                        intent="primary"
                        size="sm"
                        className="w-full"
                        onClick={logout}
                    >
                        Logout
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Sidebar